import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadCrumbElement } from '../../../../../shared/entities/breadcrumb.element.entity';
import { tap } from 'rxjs/operators';
import { DestinationSearchParams } from '../../params/destination-search.params';
import { Observable } from 'rxjs';
import { DestinationAction } from '../../model/destination-action.enum';
import { DestinationFilterComponent } from '../../components/destination-filter/destination-filter.component';
import { DestinationField } from '../../model/destination-field.enum';
import { PaginatedResponse } from '../../../../../shared/models/paginated-response';
import { DestinationResponse } from '../../responses/destination.response';
import { Pagination } from '../../../../../shared/models/pagination';
import { DestinationUtilsService } from '../../destination-utils.service';
import { BotMergeDestinationState } from '../../../../../shared/models/bot-merge-destinations-state';

@Component({
    selector: 'app-add-destination',
    templateUrl: './add-destination.component.html',
    styleUrls: ['./add-destination.component.css'],
})
export class AddDestinationComponent implements OnInit {
    @ViewChild(DestinationFilterComponent)
    destinationFilter: DestinationFilterComponent;
    readonly additionalFields = [
        DestinationAction.Prepare,
        DestinationField.HousingsImported,
    ];
    destinations: DestinationResponse[] = [];
    searchParams: DestinationSearchParams = {
        state: BotMergeDestinationState.NEW,
    };
    pagination: Pagination = {
        page: 1,
        limit: 20,
    };

    /* */
    public breadCrumbElements: Array<BreadCrumbElement> = [
        new BreadCrumbElement('tripmakery', 'javascript:void(0)'),
        new BreadCrumbElement('Bot', 'javascript:void(0)'),
        new BreadCrumbElement('Add destination', 'javascript:void(0)'),
    ];
    /* */
    public backgroundImage = '/assets/media/photos/photo21@2x.jpg';
    public containerBackgroundImage = {
        'background-image': 'url(' + this.backgroundImage + ')',
    };
    public subContainerBackgroundImage = {};
    public containerClass = { 'bg-image': true };
    public subContainerClass = { 'bg-white-op-90': true };
    public contentClass: any = {
        content: true,
        'text-center': true,
        'content-top': true,
    };
    public pyClass = { 'py-50': true };
    public h1class: any = { h1: true };
    public h2class: any = { h4: true };

    constructor(private destinationUtilsService: DestinationUtilsService) {}

    ngOnInit() {}
    ngAfterViewInit() {
        // run this after the view is initialized to ensure the filter component is available
        this.reloadDestinations();
    }

    reloadDestinations(resetPage: boolean = false) {
        if (resetPage) {
            this.pagination.page = 1;
        }
        window.scrollTo(0, 250);
        this.loadDestinations().subscribe(() => {});
    }

    actionClicked(data: {
        action: DestinationAction;
        destination: DestinationResponse;
    }) {
        this.destinationUtilsService.actionClicked(data);
    }

    private loadDestinations(): Observable<
        PaginatedResponse<DestinationResponse>
    > {
        const params = {
            ...this.pagination,
            ...this.destinationFilter.formValue,
        };
        return this.destinationUtilsService.loadDestinations(params).pipe(
            tap((data) => {
                this.destinations = data.elements;
                this.pagination = data.pagination;
            })
        );
    }
    public sendPage(page: number) {
        this.pagination.page = page;
        this.reloadDestinations();
    }
}
